import React from 'react';
import { Container, Nav, OverlayTrigger, Popover } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import footerNavItems from '../../constants/footerNavItems';

import { useAuth } from '../context';
import { DEPLOYMENT_TIER } from '../../utils/appConfig';

function MainFooter() {
  const { user } = useAuth();
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <footer className="main-footer d-flex p-2 px-3 bg-white border-top">
      <Container fluid={user ? true : undefined} className="p-0 my-auto d-flex">
        <div className="mx-auto ms-sm-auto me-sm-0 d-block d-sm-flex text-center align-items-center">
          {footerNavItems && footerNavItems.length && (
            <Nav className="me-0 me-sm-3">
              {(DEPLOYMENT_TIER === 'stage' || DEPLOYMENT_TIER === 'local') && (
                <Nav.Item className="text-light">v{process.env.RELEASE_VERSION}</Nav.Item>
              )}
              {footerNavItems.map((item) => (
                <Nav.Item className={item.classes || undefined} key={item.name}>
                  <Nav.Link
                    className="py-0 px-3 text-info"
                    as={item.to ? NavLink : undefined}
                    to={
                      item.to
                        ? { pathname: item.to, state: { from: location.pathname } }
                        : undefined
                    }
                    href={item.href || undefined}
                    target={item.href ? '_blank' : undefined}
                  >
                    {item.iconClass && (
                      <span className="d-inline-block item-icon-wrapper">
                        <i className={item.iconClass} />
                      </span>
                    )}
                    {item.title && <span className="text">{t(item.title)}</span>}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          )}
          <OverlayTrigger
            overlay={
              <Popover>
                <Popover.Body className="text-center">v{process.env.RELEASE_VERSION}</Popover.Body>
              </Popover>
            }
          >
            <span className="copyright ps-0 ps-sm-4">
              {t('footer.copyright', { year: new Date().getFullYear() })}
            </span>
          </OverlayTrigger>
        </div>
      </Container>
    </footer>
  );
}

export default MainFooter;
